module.exports = __webpack_public_path__ + "1edcd54965e7231050cda33dbe71dc1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-jester.png
// module id = 1905
// module chunks = 0